import { Consultas } from './../../providers/consultas';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, MenuController } from 'ionic-angular';
import { CategoriaNoticiasYOfertas } from '../../models/categoria.noticiasyofertas.model';
import { BuscadorPage } from '../buscador/buscador';
import { NoticiaPage } from '../noticia/noticia';
import { ToastController } from 'ionic-angular';
import { NoticiasPage } from '../noticias/noticias';

/**
 * Generated class for the CategoriaNoticiasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-categoria-noticias',
  templateUrl: 'categoria-noticias.html',
})
export class CategoriaNoticiasPage {
  public categorias:Array<CategoriaNoticiasYOfertas>;
  public loader:any;
  public idCiudad:number;
  public nombrePueblo:string;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public loadingCtrl: LoadingController,public consultas: Consultas,
    public toastCtrl: ToastController,public menuCtrl:MenuController ) {

    this.idCiudad = navParams.get("idCiudad");
    this.nombrePueblo = navParams.get("nombrePueblo");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CategoriaNoticiasPage');
  }

  ngOnInit(){
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
        this.consultas.getCategoriasNoticias(this.idCiudad).subscribe(x=>
          {
            if(!x){
              let toast = this.toastCtrl.create({
                  message: 'No hay noticias de este pueblo',
                  duration: 3000,
                  position: 'bottom'
                });

                toast.onDidDismiss(() => {
                  console.log('Dismissed toast');
                });

                toast.present();
                this.navCtrl.pop();
          }
            this.categorias = x;
            this.loader.dismiss();
          },error=>{
            console.error(error);
            this.loader.dismiss();
          }
          );
    });
  }
  goToNoticias(categoria){
    this.navCtrl.push(NoticiasPage,{idCiudad: this.idCiudad, idCategoria: categoria.idCat, nombrePueblo: this.nombrePueblo});
  }

}



// WEBPACK FOOTER //
// ./src/pages/categoria-noticias/categoria-noticias.ts